import React, { useCallback, useEffect, useMemo, useState } from "react";
import { InputField, DataTable, Button, DateInput } from "@/components";
import ColumnHelper from "@/utils/ColumnHelper";
import { useFilteredData, useApi } from "@/";
import { SpaceWrapper } from "../../components";
import { subDays } from "date-fns";
const IccLogs = () => {
  const currentDate = new Date();
  const startOfMonthDate = subDays(currentDate, 30); // Last 30 days
  const endOfMonthDate = new Date(currentDate);

  const { callApi, error, loading } = useApi();
  const [employee, setEmployee] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await callApi("/admin/getLoginLog", "GET", null);
        if (response.success && response.data) {
          console.log("Response", response.data);
          setEmployee(response.data);
        } else if (response.error) {
          console.log("Error", response.error?.message || "Unknown error");
        }
      } catch (error) {
        console.log("Error", error);
      }
    };
    fetchData();
  }, [callApi]);
  console.log("Data:::", employee);

  const [resetPageCounter, setResetPageCounter] = useState(0);
  const [filters, setFilters] = useState({
    customerName: "",
    customerID: "",
    date: { from: startOfMonthDate, to: endOfMonthDate },
  });
  const [appliedFilters, setAppliedFilters] = useState(filters);
  const filterConfig = useMemo(
    () => ({
      customerName: { type: "partial", itemKey: "employeeId.name" },
      customerID: { type: "partial", itemKey: "employeeId?.email" },
      date: { type: "date", itemKey: "loginTime" },
    }),
    []
  );

  const { data: filteredData, isLoading } = useFilteredData(
    employee,
    appliedFilters,
    filterConfig
  );
  const handleChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };
  const handleDateChange = useCallback((dateRange) => {
    setFilters((prev) => ({
      ...prev,
      date: { from: dateRange?.from || "", to: dateRange?.to || "" },
    }));
  }, []);
  const handleApply = useCallback(() => {
    setAppliedFilters(filters);
    setResetPageCounter((prev) => prev + 1);
  }, [filters]);

  // Format date values
  const formatDate = useCallback((dateString) => {
    return new Date(dateString).toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }, []);

  const columns = useMemo(
    () => [
      ColumnHelper({
        header: "Employee Name",
        accessorKey: "",
        cell: (info) => info.row.original.employeeId?.name,
        meta: {
          tooltip: (row) => row.employeeId?.name || "N/A",
        },
      }),
      ColumnHelper({
        header: "Employee Email",
        accessorKey: "",
        cell: (info) => info.row.original.employeeId?.email,
        meta: {
          tooltip: (row) => row.employeeId?.email || "N/A",
        },
      }),
      ColumnHelper({
        header: "Login Date & Time",
        accessorKey: "loginTime",
        cell: (info) => formatDate(info.row.original.loginTime),
        meta: {
          tooltip: (row) => formatDate(row?.loginTime) || "N/A",
        },
      }),
    ],
    []
  );

  const handleReset = useCallback(() => {
    const initialFilters = {
      customerName: "",
      customerID: "",
      date: { from: startOfMonthDate, to: endOfMonthDate },
    };
    setFilters(initialFilters);
    setAppliedFilters(initialFilters);
    setResetPageCounter((prev) => prev + 1);
  }, []);
  return (
    <SpaceWrapper>
      <div className="w-full flex-1 flex flex-col gap-4 p-4 pb-20 md:pb-4 relative max-w-[2000px]">
        <h1 className="text-headline4 lg:text-headline3 font-nunito text-secondary/95 font-bold">
          ICC Logs
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-4">
          <DateInput
            label="Date Filter"
            placeholder="Select start & end date"
            mode="range"
            value={filters.date}
            onChange={handleDateChange}
          />
          <InputField
            label="Customer Name"
            placeholder="Enter Customer Name"
            value={filters.customerName}
            onChange={(value) => handleChange("customerName", value)}
          />
          <InputField
            label="Customer ID"
            placeholder="Enter Customer ID"
            value={filters.orderId}
            onChange={(value) => handleChange("orderId", value)}
          />
          <div className="flex flex-row gap-2 justify-start items-end">
            <Button size="md" onClick={handleApply} className="h-12">
              Apply
            </Button>
            <Button
              variant="outline"
              size="md"
              className="h-12"
              onClick={handleReset}
            >
              Reset
            </Button>
          </div>
        </div>
        <DataTable
          columns={columns}
          tittle="ICC Logs"
          data={filteredData}
          isLoading={isLoading}
          resetPage={resetPageCounter}
          showCheckbox={false}
        />
      </div>
    </SpaceWrapper>
  );
};

export default IccLogs;
